<template>
  <dialog id="splash-banner" ref="splashBanner" v-show="shown" @click="markVisited">
    <BaseIcon
      :icon="'close'"
      class="size-26 icon"
      role="button"
      @click="markVisited"
    />
    <Advertisement @ad-loaded="handleReady" :display-at="AdDisplayAt.Splash" class="banner" />
    <BaseButton id="continue-to-site-btn" @click="markVisited">
      {{ $t("splash-banner.continue") }}
    </BaseButton>
  </dialog>
</template>
<script setup lang="ts">
/**
 * Splash banner for showing an overlay of an ad.
 *
 * The v-shown is used because content can leak through hydration in combination of the `dialog`,
 * even if it's only client side.
 */
import { AdDisplayAt } from "~/graphql/generated";
const shown = ref(false);
const splashBanner = ref<HTMLDialogElement | null>(null);
const handleReady = () => {
  if (!sessionStorage.getItem("firstVisit")) {
    shown.value = true;
    splashBanner.value?.showModal();
  }
}

const markVisited = () => {
  sessionStorage.setItem("firstVisit", "false");
  shown.value = false;
  splashBanner.value?.close();
};
</script>
<style lang="css" scoped>
#splash-banner {
  border: 0;
  background-color: transparent;
  display: grid;
  gap: 1rem;
  width: fit-content;
}

#splash-image {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
#splash-banner::backdrop {
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
}

#continue-to-site-btn {
  max-height: 50px;
  font-size: 1rem;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 5px;
}

.icon {
  justify-self: end;
  cursor: pointer;
}
</style>
